import { render } from "./Header.vue?vue&type=template&id=42d985a0"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"
script.render = render

export default script